/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1LocationStatesDropdownQueryResponse,
  GetApiV1LocationStatesDropdownQueryParams,
  GetApiV1LocationStatesDropdown401,
  GetApiV1LocationStatesDropdown500,
} from "../../types/locationStateController/GetApiV1LocationStatesDropdown.ts";

function getGetApiV1LocationStatesDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/location/states/dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna estados ordenados por nome. Quando countryId é informado, filtra pelo país correspondente. **(Requer Authorization para autenticação)**
 * @summary Lista de estados/UFs para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/location/states/dropdown}
 */
export async function getApiV1LocationStatesDropdown(
  params?: GetApiV1LocationStatesDropdownQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1LocationStatesDropdownQueryResponse,
    ResponseErrorConfig<
      GetApiV1LocationStatesDropdown401 | GetApiV1LocationStatesDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1LocationStatesDropdownUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
